<template>
  <div class="home">
    <carousel
      :data="slides"
      lang="en"
      :class="this.$isPC ? '' : 'sp-carousel'"
      width="530"
      height="120"
    />
    <h1 style="color: rgb(26, 87, 167)">
      呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call
    </h1>
    <template v-if="this.$isPC">
      <h2 class="campaign-section-heading">B-Call限定！キャンペーン情報</h2>
      <div class="campaign-section">
        <campaign-contact />
        <rental />
      </div>
    </template>
    <template v-else>
      <sp-campaign-contact />
      <sp-rental />
      <sp-phone-contact />
    </template>
    <choices :showAll="true" />
    <support />
    <contact v-if="this.$isPC" />
    <sp-contact v-else />
    <home-faq />
    <news />
    <div class="columns" style="margin-top: 30px;">
      <label class="selected" style="cursor: default;">
        <h2>
          <div style="font-size: 26px;">お役立ち</div>
          <div style="font-size: 16px;">コラム</div>
        </h2>
      </label>
    </div>
    <div class="body">
      <div class="use-scene-block">
        <router-link to="/column/60">
          <div class="use-scene-block-header">
            製造業の人手不足対策｜工場の生産性を高めて対策を進めよう！
          </div>
        </router-link>
        <p>
          製造業の人手不足が深刻化する背景として、少子高齢化や技能継承の停滞、3Kイメージによる若手離れなどが挙げられます。人手不足の原因と改善策、生産性向上に役立つツールを紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/59">
          <div class="use-scene-block-header">
            サービス業の人手不足｜原因・影響・対策について解説
          </div>
        </router-link>
        <p>
          サービス業で人手不足が起きる原因と経営への影響を整理し、採用に頼らず人手不足を改善できる具体策を解説します。少人数運営を支える呼び出しベル・チャイムも紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/58">
          <div class="use-scene-block-header">
            製造業で作業効率を上げるには？効率化が必要な理由も解説
          </div>
        </router-link>
        <p>
          製造業の現場で作業効率が下がる原因と、その改善アイデアを解説します。呼び出し・コールシステムの導入による効率化も紹介するので、製造現場での生産性を向上させましょう。
        </p>
      </div>
    </div>
    <div class="columns-list-button-wrap">
      <router-link to="/columns" class="columns-list-button">
        お役立ちコラム一覧
      </router-link>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCarousel from '@chenfengyuan/vue-carousel'
import News from '@/components/modules/News'
import Contact from '@/components/modules/Contact'
import SpContact from '@/components/modules/SpContact'
import Support from '@/components/modules/Support'
import HomeFaq from '@/components/modules/HomeFaq'
import CampaignContact from '@/components/modules/campaign/CampaignContact'
import Rental from '@/components/modules/campaign/Rental'
import SpCampaignContact from '@/components/modules/campaign/SpCampaignContact'
import SpRental from '@/components/modules/campaign/SpRental'
import SpPhoneContact from '@/components/modules/campaign/SpPhoneContact'
import Choices from '@/components/modules/choice/Choices'
import '../../js/modernizr-custom'

Vue.component(VueCarousel.name, VueCarousel)

export default {
  components: {
    News,
    Contact,
    SpContact,
    Support,
    HomeFaq,
    CampaignContact,
    Rental,
    SpCampaignContact,
    SpRental,
    SpPhoneContact,
    Choices,
  },
  title: '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
  meta:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  canonical:
    '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
  data() {
    return {
      slides: [
        `<div class="carousel-slide slide1">
          <div class="fv-overlay">
            <div class="fv-content">
              <h2 class="fv-headline"><span class="fv-accent">お客様<span class="fv-particle">を</span>待たせない</span><br><span class="fv-emphasis">呼び出しシステム</span><span class="fv-large">を</span><br><span class="fv-large">ご提供します</span></h2>
              <p class="fv-subheadline"><span class="fv-bell"><svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 15.4375C0 15.222 0.0856024 15.0153 0.237976 14.863C0.390349 14.7106 0.597012 14.625 0.8125 14.625H1.625V13C1.62796 10.5557 2.54776 8.20146 4.20261 6.40256C5.85747 4.60366 8.12694 3.49102 10.5625 3.28453V1.625H8.9375C8.72201 1.625 8.51535 1.5394 8.36298 1.38702C8.2106 1.23465 8.125 1.02799 8.125 0.8125C8.125 0.597012 8.2106 0.390349 8.36298 0.237976C8.51535 0.0856024 8.72201 0 8.9375 0H13.8125C14.028 0 14.2347 0.0856024 14.387 0.237976C14.5394 0.390349 14.625 0.597012 14.625 0.8125C14.625 1.02799 14.5394 1.23465 14.387 1.38702C14.2347 1.5394 14.028 1.625 13.8125 1.625H12.1875V3.28453C14.6231 3.49102 16.8925 4.60366 18.5474 6.40256C20.2022 8.20146 21.122 10.5557 21.125 13V14.625H21.9375C22.153 14.625 22.3597 14.7106 22.512 14.863C22.6644 15.0153 22.75 15.222 22.75 15.4375C22.75 15.653 22.6644 15.8597 22.512 16.012C22.3597 16.1644 22.153 16.25 21.9375 16.25H0.8125C0.597012 16.25 0.390349 16.1644 0.237976 16.012C0.0856024 15.8597 0 15.653 0 15.4375ZM21.9375 17.875H0.8125C0.597012 17.875 0.390349 17.9606 0.237976 18.113C0.0856024 18.2653 0 18.472 0 18.6875C0 18.903 0.0856024 19.1097 0.237976 19.262C0.390349 19.4144 0.597012 19.5 0.8125 19.5H21.9375C22.153 19.5 22.3597 19.4144 22.512 19.262C22.6644 19.1097 22.75 18.903 22.75 18.6875C22.75 18.472 22.6644 18.2653 22.512 18.113C22.3597 17.9606 22.153 17.875 21.9375 17.875Z" fill="white"/></svg></span> 様々な「コール」にお答えします</p>
              <p class="fv-note"><span class="fv-note-mark fv-note-mark--left"></span> デモ機の無料貸し出しも受付中 <span class="fv-note-mark fv-note-mark--right"></span></p>
              <a href="/contact" class="fv-cta"><span class="fv-cta-icon"><svg width="22" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/></svg></span> フォームで問い合わせる</a>
            </div>
            <div class="fv-features">
              <div class="fv-circle"><span>導入前<span class="fv-circle-small">の</span><br>相談<span class="fv-circle-small">から</span><br>提案可能</span></div>
              <div class="fv-circle"><span>導入<span class="fv-circle-small">まで</span><br>最短<span class="fv-circle-big">1</span>日！<br><small>※状況による</small></span></div>
              <div class="fv-circle"><span>導入後<span class="fv-circle-small">の</span><br>サポート体制<span class="fv-circle-small">も</span><br>充実</span></div>
            </div>
          </div>
        </div>`,
        '<a href="/choice/purpose" class="carousel-slide slide2"></a>',
        '<a href="/choice/purpose" class="carousel-slide slide3"></a>',
        '<a href="/product/beyond-ec/feature" class="carousel-slide slide4"></a>',
        '<a href="/contact" class="carousel-slide slide5"><div class="front-slide front5"></div></a>',
      ],
    }
  },
  mounted() {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.id = 'organization-schema'
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '株式会社ビーアッサ',
      alternateName: 'B-ASSA Co., Ltd.',
      url: 'https://b-call.jp/',
      description:
        '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。',
      founders: [{ '@type': 'Person', name: '浅山 豊樹' }],
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+81-76-294-4440',
          contactType: 'customer service',
          areaServed: 'JP',
          availableLanguage: ['Japanese'],
        },
      ],
      address: {
        '@type': 'PostalAddress',
        streetAddress: '石川県加賀市山中温泉中田町ハ-101',
      },
    })
    document.head.appendChild(script)
  },
  beforeDestroy() {
    const script = document.getElementById('organization-schema')
    if (script) document.head.removeChild(script)
  },
}
</script>

<style>
.carousel {
  width: 100%;
  max-width: 1400px;
}

.sp-carousel {
  max-height: 200px;
}

.carousel-slide {
  display: block;

  height: 500px;

  background-repeat: no-repeat;
  background-position: 50% 80%;
  background-size: cover;
}

.sp-carousel .carousel-slide {
  max-height: 150px;
}

.carousel-slide .front-slide {
  height: 100%;

  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
}

.sp-carousel .front-slide {
  max-height: 200px;
}

.carousel-slide.slide1 {
  background-image: url('/static/img/FV.webp');
  background-position: right center;
  width: 100%;
  height: 500px;
}

.carousel-slide.slide1 .fv-overlay {
  position: relative;

  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 3.125em 3.75em 2.5em;

  font-size: min(16px, 1.143vw);
}

.carousel-slide.slide1 .fv-content {
  max-width: 31em;
}

@media (max-width: 1099px) {
  .carousel-slide.slide1 .fv-content {
    max-width: 27em;
  }
}

.carousel-slide.slide1 .fv-headline {
  font-size: 2.625em;
  font-weight: bold;
  line-height: 1.3;

  margin: 0 0 0.5em;

  color: #ffffff;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.45);
}

@media (max-width: 1099px) {
  .carousel-slide.slide1 .fv-headline {
    font-size: 2.3em;
  }
}

.carousel-slide.slide1 .fv-emphasis {
  font-size: 1.321em;

  color: #FAE920;
}

.carousel-slide.slide1 .fv-accent {
  font-size: 1.123em;

  color: #FAE920;
}

.carousel-slide.slide1 .fv-particle {
  font-size: 0.8823em;
}

.carousel-slide.slide1 .fv-large {
  font-size: 1.123em;
}

.carousel-slide.slide1 .fv-subheadline {
  font-size: 1.25em;
  font-weight: bold;

  display: flex;
  align-items: center;

  margin: 0 0 2.25em;
  padding: 0.5625em 0;

  color: #ffffff;
  border-top: 1px solid rgba(255, 255, 255, 0.85);
  border-bottom: 1px solid rgba(255, 255, 255, 0.85);
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}

.carousel-slide.slide1 .fv-bell {
  display: inline-flex;
  align-items: center;

  margin-right: 0.8em;
  vertical-align: middle;
}

.carousel-slide.slide1 .fv-bell svg {
  display: block;
  width: 1.4375em;
  height: auto;
}

.carousel-slide.slide1 .fv-note {
  font-size: 1.25em;
  font-weight: bold;

  width: 100%;
  max-width: 17em;
  margin: 0 0 0.6em;

  white-space: nowrap;

  text-align: center;

  color: #ffffff;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}

.carousel-slide.slide1 .fv-note-mark {
  position: relative;

  display: inline-block;

  width: 0.65em;
  height: 1.4em;
  margin: 0 0.333em;

  vertical-align: middle;
}

.carousel-slide.slide1 .fv-note-mark::before {
  content: "";

  position: absolute;
  top: 5%;
  bottom: 5%;
  left: 50%;

  width: 1.5px;

  background-image: linear-gradient(to bottom, #ffffff 50%, transparent 50%);
  background-size: 100% 7px;
  background-repeat: repeat-y;
  transform-origin: center;
}

.carousel-slide.slide1 .fv-note-mark--left::before {
  transform: rotate(-32deg);
}

.carousel-slide.slide1 .fv-note-mark--right::before {
  transform: rotate(32deg);
}

.carousel-slide.slide1 .fv-cta {
  font-size: 1.25em;
  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 15.75em;
  padding: 0.7em 0.5em;
  gap: 0.5em;

  text-align: center;
  text-decoration: none;
  letter-spacing: 0.0625em;

  color: #ffffff;
  border-radius: 0.375em;
  border-bottom: 0.25em solid #b8611a;
  background-color: #e67e22;
  box-shadow: 0 0.25em 0 rgba(0, 0, 0, 0.2);

  transition: opacity 0.3s;
}

.carousel-slide.slide1 .fv-cta:hover {
  opacity: 0.7;
}

.carousel-slide.slide1 .fv-cta-icon {
  display: inline-flex;
  align-items: center;
}

.carousel-slide.slide1 .fv-cta-icon svg {
  display: block;
  width: 1.375em;
  height: auto;
}

.carousel-slide.slide1 .fv-features {
  position: absolute;
  right: 7.5em;
  bottom: 1em;

  display: flex;
  gap: 5em;
}

.carousel-slide.slide1 .fv-circle {
  font-size: 1.125em;
  font-weight: bold;
  line-height: 1.4;
  letter-spacing: 0.04em;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 8em;
  height: 8em;

  text-align: center;

  color: #ffffff;
  text-shadow: 2px 2px 4px #00000080;
  border-radius: 50%;
  background: linear-gradient(135deg, #09d7da 0%, #09d7da 15%, #0035c5 100%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.carousel-slide.slide1 .fv-circle small {
  font-size: 0.6875em;
  font-weight: bold;
  line-height: 1;

  display: inline-block;

  margin-top: -0.3em;
}

.carousel-slide.slide1 .fv-circle-big {
  font-size: 1.35em;
  line-height: 0;

  margin: 0 0.15em;
}

.carousel-slide.slide1 .fv-circle-small {
  font-size: 0.78em;
}

.carousel-slide.slide2 {
  background-image: url('../../assets/slide2.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide3 {
  background-image: url('../../assets/slide3.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide4 {
  background-image: url('../../assets/slide4.png');
  width: 100%;
  height: 500px;
}

.carousel-slide.slide5 {
  background-image: url('../../assets/scene4.jpg');
  width: 100%;
  height: 500px;
}

.front-slide.front1 {
  background-image: url('../../assets/s1.png');
}

.front-slide.front5 {
  background-image: url('../../assets/s5.png');
}

.home .body {
  display: flex;
  justify-content: center;

  max-width: 960px;
  padding: 0 8px;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
}

.home .body .use-scene-block {
  align-self: flex-start;

  margin: 20px 15px;

  text-align: left;

  flex: 1;
}

.home .body .use-scene-block img {
  display: block;

  width: 100%;
  max-width: 420px;
  height: auto;
  margin: 10px auto;

  background-color: #eee;
}

.home .body .use-scene-block p {
  font-size: 12px;
  line-height: 22px;

  margin: 8px 0 0 0;
}

.home .body .use-scene-block .use-scene-block-header {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.5;
  min-height: calc(1.5em * 3);

  padding-left: 10px;

  border-left: 4px solid rgb(45, 183, 68);

  @media only screen and (max-width: 600px) {
    min-height: auto;
  }
}

.columns {
  display: flex;
  justify-content: space-around;

  width: 50%;
  margin: 0 auto 30px;
}

.columns label {
  font-weight: bold;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  width: 120px;
  height: 120px;

  cursor: pointer;
  text-align: center;

  color: white;
  border-radius: 50%;
  background: rgb(35, 145, 235);
}

.columns label.selected {
  background: rgb(26, 87, 167);
}

.campaign-section-heading {
  font-size: 26px;
  font-weight: bold;

  margin: 10px 0 20px;

  text-align: center;

  color: rgb(26, 87, 167);
}

.campaign-section {
  display: flex;
  justify-content: center;

  gap: 40px;

  margin-bottom: 30px;
}

.industry-scene-column-header {
  font-weight: bold;
  display: flex;
  justify-content: right;
  max-width: 960px;
  width: 100%;
  margin-right: 32px;
}

.columns-list-button-wrap {
  display: flex;
  justify-content: center;

  width: 100%;
  margin-top: 30px;
  padding: 0 5% 30px;

  box-sizing: border-box;
}

.columns-list-button {
  font-size: 18px;
  font-weight: bold;

  display: block;

  width: 100%;
  max-width: 320px;
  padding: 14px 10px;

  text-align: center;
  text-decoration: none;
  letter-spacing: 1px;

  color: #ffffff;
  border-radius: 6px;
  border-bottom: 4px solid rgb(15, 58, 120);
  background-color: rgb(26, 87, 167);
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);

  transition: opacity 0.3s;
}

.columns-list-button:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue